import React, { useState, useEffect } from 'react';
import DataWrapper from './DataWrapper';
import AddonServices from 'services/AddonServices';
import useToggleDrawer from 'hooks/useToggleDrawer';
import PageTitle from 'components/Typography/PageTitle';
import MainDrawer from 'components/drawer/MainDrawer';
import AddonDrawer from 'components/drawer/AddonDrawer';
import NotFound from 'components/table/NotFound';
import { useContext } from 'react';
import { SidebarContext } from 'context/SidebarContext';
import { FiRefreshCcw } from 'react-icons/fi';
import DeleteModal from 'components/modal/DeleteModal';

import useAsync from 'hooks/useAsync';
import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import { FiPlus } from 'react-icons/fi';
import sidebar from 'routes/sidebar';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import AddonsTable from 'components/addons/AddonsTable';

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const AddonType = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
	const [searchText, setSearchText] = useState('');
	const { data, loading, error } = useAsync(() =>
		AddonServices.getAllAddonType()
	);

	const isDataArray = Array.isArray(data?.data); // Check if data is an array
	const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

	const [status, setStatus] = useState('');

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'addons' && perm.view === 1
		  );

	const hideDelete = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'addons' && perm.delete === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'addons' && perm.edit === 1
		  );

	const hideAdd = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'addons' && perm.add === 1
		  );

	const hideExport = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'addons' && perm.export === 1
		  );

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	const { title, serviceId } = useToggleDrawer();
	// Contains the column headers and table data in the required format for CSV
	const csvData = [
		['S.No','Addons Type', 'Description', 'Price'],
		...safeData?.map(({ name, description, price }, index) => [
			index + 1,
			name,
			description,
			price,
		]),
	];

	const filteredData = safeData.filter(
		(item) =>
			(item.name !== null &&
				item.name.toLowerCase().includes(searchText.toLowerCase())) ||
			(item.price && item.price.toString().includes(searchText)) ||
			(item.tax && item.tax.toString().includes(searchText))
	);

	const handleRefresh = () => {
		setIsUpdate(true);
	};
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />

					<style>{style}</style>
					<PageTitle sidebar={sidebar().sidebar} />

					<MainDrawer>
						<AddonDrawer id={serviceId} />
					</MainDrawer>

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<form className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										value={searchText}
										onChange={(e) => setSearchText(e.target.value)}
										placeholder="Quick Search"
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Addon Type
									</Button>
								)}

								{hideExport && (
									<ExportDataXlsx
										title="Addons Type List"
										exportDataXlsx={csvData}
										fileNames="Addons Type List"
									/>
								)}

								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</form>
						</CardBody>
					</Card>

					{/* <div className="data-table-container"> */}
						<DataWrapper loading={loading} error={error} status={status}>
							{filteredData .length > 0 ? (
								<TableContainer
									className="mb-8"
									style={{
										maxHeight: '65vh',
										overflowY: 'scroll',
										scrollbarWidth: 'thin',
									}}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize sticky top-0 z-10">
											<tr>
												<TableCell className="text-center">Sl.No.</TableCell>
												<TableCell className="text-center">Type</TableCell>
												<TableCell className="text-center">City</TableCell>
												<TableCell className="text-center">Price</TableCell>
												{/* <TableCell className="text-center">Tax</TableCell> */}
												<TableCell className="text-center">Actions</TableCell>
											</tr>
										</TableHeader>

										<AddonsTable
											roledata={filteredData}
											hideEdit={hideEdit}
											hideDelete={hideDelete}
										/>
									</Table>
								</TableContainer>
							) : (
								// Show NotFound if there is no data
								<NotFound title="There are no Addon." />
							)}
						</DataWrapper>
					{/* </div> */}
				</>
			)}
		</>
	);
};

export default AddonType;



// import React, {
//   useState,
//   useEffect,
//   useContext,
// } from "react";

// import DataWrapper from "./DataWrapper";

// import AddonServices from "services/AddonServices";

// import useToggleDrawer from "hooks/useToggleDrawer";

// import PageTitle from "components/Typography/PageTitle";

// import MainDrawer from "components/drawer/MainDrawer";
// import AddonDrawer from "components/drawer/AddonDrawer";

// import NotFound from "components/table/NotFound";

// import { SidebarContext } from "context/SidebarContext";

// import { FiRefreshCcw } from "react-icons/fi";

// import DeleteModal from "components/modal/DeleteModal";

// import useAsync from "hooks/useAsync";

// import {
//   Card,
//   CardBody,
//   Table,
//   TableCell,
//   TableContainer,
//   TableHeader,
// } from "@windmill/react-ui";

// import sidebar from "routes/sidebar";

// import ExportDataXlsx from "components/common/ExportDataXlsx";

// import AddonsTable from "components/addons/AddonsTable";
// import QuickSearch from "components/common/QuickSearch";



// const AddonType = () => {


//   const adminInfo = localStorage.getItem(
//     "adminInfo"
//   )
//     ? JSON.parse(
//         localStorage.getItem("adminInfo")
//       )
//     : null;


//   const {
//     toggleDrawer,
//     setIsUpdate,
//   } = useContext(SidebarContext);


//   const [
//     searchText,
//     setSearchText,
//   ] = useState("");

//   const [
//     backendSearchData,
//     setBackendSearchData,
//   ] = useState(null);

//   const [
//     searchLoading,
//     setSearchLoading,
//   ] = useState(false);


//   const {
//     data,
//     loading,
//     error,
//   } = useAsync(() =>
//     AddonServices.getAllAddonType()
//   );


//   const isDataArray =
//     Array.isArray(data?.data);

//   const safeData = isDataArray
//     ? data.data
//     : [];


//   const [
//     status,
//     setStatus,
//   ] = useState("");


//   useEffect(() => {
//     if (data?.status) {
//       setStatus(data.status);
//     } else {
//       setStatus(false);
//     }
//   }, [data?.status]);



//   const {
//     title,
//     serviceId,
//   } = useToggleDrawer();



//   const isAdmin =
//     adminInfo?.id === 1;


//   const hideView = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//         (perm) =>
//           perm.id_tab === "addons" &&
//           perm.view === 1
//       );


//   const hideDelete = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//         (perm) =>
//           perm.id_tab === "addons" &&
//           perm.delete === 1
//       );


//   const hideEdit = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//         (perm) =>
//           perm.id_tab === "addons" &&
//           perm.edit === 1
//       );


//   const hideAdd = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//         (perm) =>
//           perm.id_tab === "addons" &&
//           perm.add === 1
//       );


//   const hideExport = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//         (perm) =>
//           perm.id_tab === "addons" &&
//           perm.export === 1
//       );


//   const filteredData =
//     safeData.filter((item) => {

//       if (!searchText) {
//         return true;
//       }

//       const search =
//         searchText
//           .toLowerCase()
//           .trim();

//       return (
//         item?.name
//           ?.toString()
//           .toLowerCase()
//           .includes(search) ||

//         item?.description
//           ?.toString()
//           .toLowerCase()
//           .includes(search) ||

//         item?.price
//           ?.toString()
//           .includes(search) ||

//         item?.tax
//           ?.toString()
//           .includes(search)
//       );
//     });


//   const handleBackendSearch = async (
//     search
//   ) => {

//     const trimmedSearch =
//       search?.trim();


//     if (!trimmedSearch) {
//       setBackendSearchData(null);
//       return;
//     }

//     try {

//       setSearchLoading(true);

//       const response =
//         await AddonServices.searchAddonType(
//           trimmedSearch
//         );

//       if (
//         response &&
//         Array.isArray(response.data)
//       ) {
//         setBackendSearchData(
//           response.data
//         );
//       } else {
//         setBackendSearchData([]);
//       }

//     } catch (error) {

//       console.error(
//         "Addon search error:",
//         error
//       );

//       setBackendSearchData([]);

//     } finally {

//       setSearchLoading(false);

//     }
//   };


//   const displayData =
//     backendSearchData !== null
//       ? backendSearchData
//       : filteredData;

//   const handleClearSearch = () => {

//     setSearchText("");

//     setBackendSearchData(null);

//   };


//   const handleRefresh = () => {

//     setSearchText("");

//     setBackendSearchData(null);

//     setIsUpdate(true);

//   };

//   const csvData = [
//     [
//       "S.No",
//       "Addons Type",
//       "Description",
//       "Price",
//     ],

//     ...safeData.map(
//       (
//         {
//           name,
//           description,
//           price,
//         },
//         index
//       ) => [
//         index + 1,
//         name,
//         description,
//         price,
//       ]
//     ),
//   ];


//   return (
//     <>
//       {hideView && (
//         <>

//           <DeleteModal
//             id={serviceId}
//             title={title}
//           />

//           <PageTitle
//             sidebar={
//               sidebar().sidebar
//             }
//           />

//           <MainDrawer>
//             <AddonDrawer
//               id={serviceId}
//             />
//           </MainDrawer>

//           <Card
//             className="
//               min-w-0
//               shadow-xs
//               overflow-hidden
//               bg-white
//               dark:bg-gray-800
//               mb-5
//             "
//           >

//             <CardBody>

//               <div
//                 className="
//                   flex
//                   flex-col
//                   lg:flex-row
//                   gap-4
//                   items-center
//                 "
//               >

//                 <div className="flex-1 w-full">

//                   <QuickSearch
//                     value={searchText}
//                     onChange={
//                       setSearchText
//                     }
//                     onSearch={
//                       handleBackendSearch
//                     }
//                     onClear={
//                       handleClearSearch
//                     }
//                     loading={
//                       searchLoading
//                     }
//                     placeholder="Quick Search Addon..."
//                   />

//                 </div>


//                 {/* =========================================
//                     ADD
//                 ========================================= */}

//                 {hideAdd && (
//                   <button
//                     type="button"
//                     onClick={
//                       toggleDrawer
//                     }
//                     className="
//                       h-10
//                       px-5
//                       rounded-md
//                       bg-green-600
//                       text-white
//                       whitespace-nowrap
//                       hover:bg-green-700
//                     "
//                   >
//                     + Add Addon Type
//                   </button>
//                 )}


//                 {/* =========================================
//                     EXPORT
//                 ========================================= */}

//                 {hideExport && (
//                   <ExportDataXlsx
//                     title="Addons Type List"
//                     exportDataXlsx={
//                       csvData
//                     }
//                     fileNames="Addons Type List"
//                   />
//                 )}


//                 {/* =========================================
//                     REFRESH
//                 ========================================= */}

//                 <FiRefreshCcw
//                   onClick={
//                     handleRefresh
//                   }
//                   cursor="pointer"
//                   size={20}
//                   className="
//                     text-gray-500
//                     hover:text-green-600
//                   "
//                 />

//               </div>

//             </CardBody>

//           </Card>


//           {/* =================================================
//               DATA
//           ================================================= */}

//           <DataWrapper
//             loading={
//               loading ||
//               searchLoading
//             }
//             error={error}
//             status={status}
//           >

//             {displayData.length > 0 ? (

//               <TableContainer
//                 className="mb-8"
//                 style={{
//                   maxHeight:
//                     "65vh",
//                   overflowY:
//                     "scroll",
//                   scrollbarWidth:
//                     "thin",
//                 }}
//               >

//                 <Table>

//                   {/* ========================================
//                       HEADER
//                   ======================================== */}

//                   <TableHeader
//                     className="
//                       custom-table-header
//                       capitalize
//                       sticky
//                       top-0
//                       z-10
//                     "
//                   >

//                     <tr>

//                       <TableCell className="text-center">
//                         Sl.No.
//                       </TableCell>

//                       <TableCell className="text-center">
//                         Type
//                       </TableCell>

//                       <TableCell className="text-center">
//                         City
//                       </TableCell>

//                       <TableCell className="text-center">
//                         Price
//                       </TableCell>

//                       <TableCell className="text-center">
//                         Actions
//                       </TableCell>

//                     </tr>

//                   </TableHeader>


//                   {/* ========================================
//                       TABLE DATA
//                   ======================================== */}

//                   <AddonsTable
//                     roledata={
//                       displayData
//                     }
//                     hideEdit={
//                       hideEdit
//                     }
//                     hideDelete={
//                       hideDelete
//                     }
//                   />

//                 </Table>

//               </TableContainer>

//             ) : (

//               <NotFound
//                 title={
//                   backendSearchData !==
//                   null
//                     ? "No matching addons found."
//                     : "There are no Addon."
//                 }
//               />

//             )}

//           </DataWrapper>

//         </>
//       )}
//     </>
//   );
// };

// export default AddonType;